// Instalación de la app (PWA): registra el service worker y gestiona el prompt
// "Instalar" (Android/escritorio). En iOS se instala desde Compartir → Añadir a inicio.
export const pwa = {
  deferred: null,
  installed: false,
  onChange: null,

  init() {
    // El service worker solo en producción (en desarrollo interfería con el recargado).
    const isProd = !(import.meta && import.meta.env && import.meta.env.DEV);
    if (isProd && 'serviceWorker' in navigator) {
      // Si ya había un SW controlando, un cambio de controlador = versión nueva activa:
      // recargamos UNA vez al iniciar para servir el contenido actualizado.
      const hadController = !!navigator.serviceWorker.controller;
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!hadController || reloaded) return; // en la 1ª instalación no recargamos
        reloaded = true;
        window.location.reload();
      });
      window.addEventListener('load', () => {
        // Ruta relativa: funciona en la raíz del dominio o en un subdirectorio.
        navigator.serviceWorker.register('sw.js').then((reg) => {
          reg.update?.(); // al iniciar, comprueba si hay contenido nuevo que descargar
        }).catch(() => {});
      });
    }
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferred = e;
      this.onChange?.();
    });
    window.addEventListener('appinstalled', () => {
      this.installed = true;
      this.deferred = null;
      this.onChange?.();
    });
  },

  isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  },
  isIOS() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
  },
  /** ¿Hay prompt nativo disponible (Android/escritorio)? */
  canPrompt() { return !!this.deferred && !this.isStandalone(); },
  /** ¿Mostrar instrucciones (iOS, que no tiene prompt)? */
  needsIOSHint() { return this.isIOS() && !this.isStandalone(); },
  /** Mostramos el botón siempre que NO esté ya instalada (así el usuario siempre tiene guía). */
  installable() { return !this.isStandalone(); },

  async prompt() {
    if (!this.deferred) return false;
    this.deferred.prompt();
    let outcome = 'dismissed';
    try { ({ outcome } = await this.deferred.userChoice); } catch { /* noop */ }
    this.deferred = null;
    this.onChange?.();
    return outcome === 'accepted';
  },
};
